import React, { Component, RefObject } from "react";
import { HotTable, HotColumn } from "@handsontable/react";
import {Checkbox,Pagination} from "antd";
import { queryPreviewData } from "../upload.api";
interface iProps {
  url: string;
  importToken: string;
  onReady: () => void;
}
export default class DataConfirm extends Component<iProps> {
  private columnDefines = [];
  state = {
    rowDataList: {
      content: [],
      pageNumber: 0,
      pageSize: 0,
      totalElements: 0,
      totalPages: 0,
    },
    rowNumber: 0,
    errorNumber: 0,
    colHeaders: [],
    columns:[],
    data: [],
    rowHeaders: [],
    onlyShowErrorData: false,
  };
  queryPreviewData = async () => {
    let { data } = await queryPreviewData(
      {
        importToken: this.props.importToken,
        onlyShowError: true,
        pageNumber: 1,
        pageSize: 500,
      },
      this.props.url
    );
    let { columnDefines, rowDataList, rowNumber, errorNumber = 0 } = data;
    this.columnDefines = columnDefines;
    await this.setState({
      rowDataList,
      rowNumber,
      errorNumber,
    });
    this.initColHeadersAndColumns();
    this.initData();
  };
  componentDidMount() {
    window["DataConfirm"] = this;
    this.props.onReady();
    window.setTimeout(()=>{
      this.queryPreviewData();
    },200)
  }
  initData = () => {
    let data = [];
    let rowHeaders = [];
    let { content = [] } = this.state.rowDataList;
    for (let item of content) {
      rowHeaders.push(item.rowNumber);
      data.push([
        item.checkState
          ? `<span style="color:green">成功</span>`
          : `<span style="color:red">失败</span>`,
        ...item.cellDatas.map((d) => d),
      ]);
    }
    this.setState({
      rowHeaders,
      data,
    });
  };
  initColHeadersAndColumns = () => {
    let colHeaders = [];
    let columns = [];
    let columnDefines = [];
    colHeaders.push("状态");
   
    for (let i=0; i<this.columnDefines.length;i++) {
      let col=this.columnDefines[i];
      columnDefines.push(col.columnName);
      columns.push({
        data: i,
        type: 'text',
        renderer: (instance, td, row, col, prop, value, cellProperties)=>{
          td.innerHTML =typeof value==='object'? value.data:value;
          return td
        },
        
      });
    }
    columns.push({
      data: this.columnDefines.length,
      type: 'text',
      renderer: (instance, td, row, col, prop, value, cellProperties)=>{
        td.innerHTML =typeof value==='object'? value.data:value;
        return td
      },
      
    });
    colHeaders = [...colHeaders, ...columnDefines];
    this.setState({
      colHeaders,
      columns
    });
  };
  get cell() {
    let cell = [];
    let { content = [] } = this.state.rowDataList;
    for (let row = 0; row < content.length; row++) {
      let item = content[row];
      for (let col = 0; col < item.cellDatas.length; col++) {
        let colData = item.cellDatas[col];
        colData.checkError &&
          cell.push({ row, col: col + 1, comment: { value: colData.cellErrorMsg } });
      }
    }
    console.log(cell)
    return cell;
  }
  onFilterChange = (e) => {
    this.setState({
      onlyShowErrorData: e.target.checked,
    });
  };
  onShowSizeChange = () => {};
  onPageChange = () => {};
  render() {
    let {
      rowNumber,
      errorNumber,
      rowDataList,
      colHeaders,
      columns,
      rowHeaders,
      data
    } = this.state;
    let settings = {
      columnHeaderHeight: 26,
      comments: true,
      colHeaders,
      columns,
      cell: this.cell,
      rowHeaders,
      fixedColumnsLeft: 1,
      data,
      width: 904,
      height: "258",
      stretchH: "all" as "all" | "none" | "last",
      licenseKey: "non-commercial-and-evaluation",
      manualColumnResize: true,
      readOnly: true,
    };
    return (
      <div>
        <div className="data-confirm-header">
          <div className="title">
            *共{rowNumber}条，错误{errorNumber}
          </div>
          <div className="action">
            <Checkbox
              checked={this.state.onlyShowErrorData}
              onChange={this.onFilterChange}
            >
              只看错误数据
            </Checkbox>
          </div>
        </div>
        {columns.length > 0  && (
          <HotTable settings={settings}></HotTable>
        )}
        <div className="data-confirm-footer">
          <div className="title"></div>
          <div className="action">
            <Pagination
              showSizeChanger
              showQuickJumper
              onShowSizeChange={this.onShowSizeChange}
              onChange={this.onPageChange}
              defaultCurrent={1}
              current={rowDataList.pageNumber}
              pageSize={rowDataList.pageSize}
              total={rowDataList.totalElements}
              pageSizeOptions={['10', '20', '50', '100', '200', '500']}
            ></Pagination>
          </div>
        </div>
      </div>
    );
  }
}
